import { render, staticRenderFns } from "./solid-border.vue?vue&type=template&id=6daff4fe&scoped=true&"
import script from "./solid-border.vue?vue&type=script&lang=js&"
export * from "./solid-border.vue?vue&type=script&lang=js&"
import style0 from "./solid-border.vue?vue&type=style&index=0&id=6daff4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daff4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6daff4fe')) {
      api.createRecord('6daff4fe', component.options)
    } else {
      api.reload('6daff4fe', component.options)
    }
    module.hot.accept("./solid-border.vue?vue&type=template&id=6daff4fe&scoped=true&", function () {
      api.rerender('6daff4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/government/sm-union/components/solid-border.vue"
export default component.exports